var render = function() {
  var this$1 = this
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "hazardousCommodities" },
    [
      _c(
        "v-layout",
        {
          staticClass: "title",
          attrs: { "align-baseline": "", "justify-space-between": "" }
        },
        [
          !_vm.readonly
            ? [
                _c("v-flex", { attrs: { xs2: "" } }, [
                  _vm._v(_vm._s(_vm.$t("hazardousMaterials")) + ":")
                ]),
                _vm._v(" "),
                _c(
                  "v-flex",
                  { attrs: { md2: "" } },
                  [
                    _c("v-select", {
                      staticClass: "table-item",
                      attrs: {
                        "hide-details": "",
                        placeholder: _vm.$t("dangerousGoods"),
                        items: _vm.dangerousGoodsOptions,
                        rules: [
                          _vm.showNone || _vm.fieldIsRequired("dangerousGoods")
                        ],
                        "item-text": "text",
                        "menu-props": { returnValue: "value" }
                      },
                      model: {
                        value: _vm.modelDangerousGoods,
                        callback: function($$v) {
                          _vm.modelDangerousGoods = $$v
                        },
                        expression: "modelDangerousGoods"
                      }
                    })
                  ],
                  1
                )
              ]
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-flex",
            { attrs: { xs2: "" } },
            [
              _vm.isBattery
                ? _c("v-text-field", {
                    staticClass: "required_field",
                    attrs: {
                      "hide-details": "",
                      readonly: _vm.readonly,
                      label: _vm.$t("offerorName"),
                      rules: [_vm.fieldIsRequired("offerorName")]
                    },
                    model: {
                      value: _vm.modelOfferorName,
                      callback: function($$v) {
                        _vm.modelOfferorName = $$v
                      },
                      expression: "modelOfferorName"
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            { attrs: { xs3: "" } },
            [
              _vm.isBattery
                ? _c("v-text-field", {
                    staticClass: "required_field",
                    attrs: {
                      "hide-details": "",
                      readonly: _vm.readonly,
                      label: _vm.$t("emergencyContactNumber"),
                      rules: [
                        _vm.fieldIsRequired("emergencyContactNumber"),
                        _vm.fieldIsPhone("emergencyContactNumber")
                      ]
                    },
                    model: {
                      value: _vm.modelEmergencyContactNumber,
                      callback: function($$v) {
                        _vm.modelEmergencyContactNumber = $$v
                      },
                      expression: "modelEmergencyContactNumber"
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _vm.isBattery
            ? _c(
                "v-flex",
                { attrs: { xs2: "" } },
                [
                  _c("PackagingSelector", {
                    attrs: {
                      packagings: _vm.packagings,
                      "show-details": false
                    },
                    on: { select: _vm.onSelectPackaging }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-flex",
            _vm._b(
              {},
              "v-flex",
              ((_obj = {}), (_obj["xs" + (_vm.readonly ? 5 : 2)] = true), _obj),
              false
            )
          )
        ],
        2
      ),
      _vm._v(" "),
      _vm.isLithiumEnabled
        ? _c(
            "v-card",
            { staticClass: "lithium-batteries-card mt-3" },
            [
              _c(
                "v-card-text",
                [
                  _c(
                    "v-layout",
                    { staticClass: "mb-3", attrs: { "align-center": "" } },
                    [
                      _c(
                        "v-flex",
                        {
                          staticClass: "title",
                          staticStyle: {
                            color: "#1976D2",
                            "font-weight": "bold",
                            "font-size": "16px"
                          }
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("lithiumBatteries")) +
                              "\n        "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-tooltip",
                        {
                          attrs: { bottom: "", "max-width": "400" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function(ref) {
                                  var on = ref.on
                                  return [
                                    _c(
                                      "v-icon",
                                      _vm._g(
                                        {
                                          staticClass: "mr-2",
                                          attrs: { color: "primary" }
                                        },
                                        on
                                      ),
                                      [_vm._v("help")]
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            2475941064
                          )
                        },
                        [
                          _vm._v(" "),
                          _c("div", [
                            _vm._v(_vm._s(_vm.$t("lithiumBatteriesHelp")))
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c("v-switch", {
                        staticClass: "mt-0",
                        attrs: { "hide-details": "" },
                        on: { change: _vm.onLithiumToggle },
                        model: {
                          value: _vm.lithiumEnabled,
                          callback: function($$v) {
                            _vm.lithiumEnabled = $$v
                          },
                          expression: "lithiumEnabled"
                        }
                      }),
                      _vm._v(" "),
                      _c("v-icon", { staticClass: "ml-2" }, [
                        _vm._v("battery_charging_full")
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    {
                      staticClass: "grey--text text--darken-1 mb-4",
                      staticStyle: { "font-size": "13px" }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("lithiumBatteriesDescription")) +
                          "\n      "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-layout",
                    { attrs: { column: "" } },
                    _vm._l(_vm.lithiumBatteryOptions, function(option) {
                      return _c("v-checkbox", {
                        key: option.value,
                        staticClass: "mb-2",
                        attrs: {
                          value: option.value,
                          label: option.label,
                          "hide-details": ""
                        },
                        on: { change: _vm.onLithiumTypeChange },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "label",
                              fn: function() {
                                return [
                                  _c(
                                    "v-layout",
                                    { attrs: { "align-center": "" } },
                                    [
                                      _c("span", [
                                        _vm._v(_vm._s(option.label))
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "v-tooltip",
                                        {
                                          attrs: {
                                            bottom: "",
                                            "max-width": "300"
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "activator",
                                                fn: function(ref) {
                                                  var on = ref.on
                                                  return [
                                                    _c(
                                                      "v-icon",
                                                      _vm._g(
                                                        {
                                                          staticClass: "ml-2",
                                                          attrs: {
                                                            color: "primary",
                                                            small: ""
                                                          }
                                                        },
                                                        on
                                                      ),
                                                      [_vm._v("help")]
                                                    )
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        },
                                        [
                                          _vm._v(" "),
                                          _c("div", [
                                            _vm._v(_vm._s(option.tooltip))
                                          ])
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              },
                              proxy: true
                            }
                          ],
                          null,
                          true
                        ),
                        model: {
                          value: _vm.selectedLithiumTypes,
                          callback: function($$v) {
                            _vm.selectedLithiumTypes = $$v
                          },
                          expression: "selectedLithiumTypes"
                        }
                      })
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _vm.lithiumError
                    ? _c(
                        "v-alert",
                        {
                          staticClass: "mt-3",
                          attrs: { value: true, type: "error", icon: "error" }
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(_vm.$t("lithiumBatteryRequired")) +
                              "\n      "
                          )
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.dangerousGoods === "LITHIUM_BATTERY"
        ? _c(
            "v-card",
            { staticClass: "lithium-settings-card" },
            [
              _c(
                "v-card-text",
                [
                  _c(
                    "v-layout",
                    { staticClass: "mb-3", attrs: { "align-center": "" } },
                    [
                      _c(
                        "v-flex",
                        [
                          _c("v-checkbox", {
                            staticClass: "mt-0",
                            attrs: {
                              label: _vm.$t("printSafetyDocument"),
                              "hide-details": ""
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "append",
                                  fn: function() {
                                    return [
                                      _c(
                                        "v-tooltip",
                                        {
                                          attrs: {
                                            bottom: "",
                                            "max-width": "400"
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "activator",
                                                fn: function(ref) {
                                                  var on = ref.on
                                                  return [
                                                    _c(
                                                      "v-icon",
                                                      _vm._g(
                                                        {
                                                          staticClass: "ml-2",
                                                          attrs: {
                                                            color: "primary"
                                                          }
                                                        },
                                                        on
                                                      ),
                                                      [_vm._v("help")]
                                                    )
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            false,
                                            3814387862
                                          )
                                        },
                                        [
                                          _vm._v(" "),
                                          _c("div", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "printSafetyDocumentTooltip"
                                                )
                                              )
                                            )
                                          ])
                                        ]
                                      )
                                    ]
                                  },
                                  proxy: true
                                }
                              ],
                              null,
                              false,
                              1616471490
                            ),
                            model: {
                              value: _vm.localIsPrintSafetyDocument,
                              callback: function($$v) {
                                _vm.localIsPrintSafetyDocument = $$v
                              },
                              expression: "localIsPrintSafetyDocument"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.localIsPrintSafetyDocument
                    ? _c(
                        "v-layout",
                        { staticClass: "ml-4" },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs6: "" } },
                            [
                              _c("ETDSelector", {
                                attrs: {
                                  label: _vm.$t("signatureImage"),
                                  placeholder: _vm.$t(
                                    "selectOrUploadLetterhead"
                                  ),
                                  containerWidth: "100%",
                                  rules: [_vm.fieldIsRequired("signatureImage")]
                                },
                                on: {
                                  imageUploaded: _vm.handleImageUploaded,
                                  imageDeleted: _vm.handleImageDeleted,
                                  change: _vm.handleImageChange
                                },
                                model: {
                                  value: _vm.localSignatureCode,
                                  callback: function($$v) {
                                    _vm.localSignatureCode = $$v
                                  },
                                  expression: "localSignatureCode"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isBattery
        ? [
            _c("v-data-table", {
              staticClass: "elevation-2 mt-2",
              attrs: {
                headers: _vm.headers,
                items: _vm.value,
                "hide-actions": ""
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "items",
                    fn: function(props) {
                      return [
                        _c("td", { staticClass: "subheading" }, [
                          _vm._v(_vm._s(props.item.idNumber))
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-left" }, [
                          _vm._v(_vm._s(props.item.dotShippingName))
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-left" }, [
                          _vm._v(_vm._s(props.item.hazardClass))
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-left" }, [
                          _vm._v(
                            _vm._s(
                              _vm.convertWeight(
                                props.item.commodityWeight,
                                props.item.isMeasurementMetric
                              )
                            ) + _vm._s(_vm.unit)
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticClass: "text-xs-left" },
                          [
                            props.item.packaging
                              ? [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(props.item.packaging.name || "-") +
                                      "\n            "
                                  ),
                                  _c(
                                    "span",
                                    {
                                      staticClass: "grey--text text--lighten-1"
                                    },
                                    [
                                      _vm._v(
                                        "\n              (" +
                                          _vm._s(props.item.packaging.length) +
                                          "x" +
                                          _vm._s(props.item.packaging.width) +
                                          "x" +
                                          _vm._s(props.item.packaging.height) +
                                          _vm._s(
                                            props.item.packaging
                                              .isMeasurementMetric
                                              ? "cm"
                                              : '"'
                                          ) +
                                          ")\n            "
                                      )
                                    ]
                                  )
                                ]
                              : [_vm._v("-")]
                          ],
                          2
                        ),
                        _vm._v(" "),
                        !_vm.readonly
                          ? _c(
                              "td",
                              { staticClass: "text-xs-center" },
                              [
                                _c(
                                  "v-menu",
                                  {
                                    ref: "menu" + props.index,
                                    attrs: {
                                      "offset-y": "",
                                      "close-on-content-click": false
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "activator",
                                          fn: function(ref) {
                                            var on = ref.on
                                            return [
                                              _c(
                                                "v-btn",
                                                _vm._g(
                                                  {
                                                    attrs: {
                                                      small: "",
                                                      icon: "",
                                                      dark: "",
                                                      flat: "",
                                                      color: "primary"
                                                    }
                                                  },
                                                  on
                                                ),
                                                [
                                                  _c("v-icon", [
                                                    _vm._v("expand_more")
                                                  ])
                                                ],
                                                1
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  },
                                  [
                                    _vm._v(" "),
                                    _c(
                                      "v-list",
                                      _vm._l(_vm.packagings, function(
                                        item,
                                        index
                                      ) {
                                        return _c(
                                          "v-list-tile",
                                          {
                                            key: index,
                                            on: {
                                              click: function($event) {
                                                return _vm.selectPackagingForCommodity(
                                                  item,
                                                  props.index
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _c(
                                              "v-list-tile-content",
                                              [
                                                _c("v-list-tile-title", [
                                                  _vm._v(_vm._s(item.name))
                                                ]),
                                                _vm._v(" "),
                                                _c("v-list-tile-sub-title", [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(item.length) +
                                                      "x" +
                                                      _vm._s(item.width) +
                                                      "x" +
                                                      _vm._s(item.height) +
                                                      _vm._s(
                                                        item.isMeasurementMetric
                                                          ? "cm"
                                                          : '"'
                                                      ) +
                                                      "\n                  "
                                                  )
                                                ])
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      }),
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-btn",
                                  {
                                    attrs: { icon: "" },
                                    on: {
                                      click: function($event) {
                                        return _vm.deleteCommodity(props.index)
                                      }
                                    }
                                  },
                                  [_c("v-icon", [_vm._v("delete")])],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e()
                      ]
                    }
                  }
                ],
                null,
                false,
                1912542048
              )
            }),
            _vm._v(" "),
            !_vm.readonly
              ? _c(
                  "v-form",
                  { ref: "form", attrs: { "lazy-validation": "" } },
                  [
                    _c(
                      "v-layout",
                      {
                        staticStyle: { margin: "10px 0" },
                        attrs: {
                          "align-baseline": "",
                          "justify-space-between": ""
                        }
                      },
                      [
                        _c(
                          "v-flex",
                          { attrs: { xs6: "" } },
                          [
                            _c("v-select", {
                              attrs: {
                                "hide-details": "",
                                items: _vm.batteries,
                                "item-text": "text",
                                "item-value": "value",
                                rules: [_vm.fieldIsRequired("battery")],
                                label: _vm.$t("dotShippingName")
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "item",
                                    fn: function(ref) {
                                      var item = ref.item
                                      return [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(
                                              item.value + " " + item.text
                                            ) +
                                            "\n            "
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                2514999532
                              ),
                              model: {
                                value: _vm.form.idNumber,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "idNumber", $$v)
                                },
                                expression: "form.idNumber"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-flex",
                          { attrs: { xs2: "" } },
                          [
                            _c("v-text-field", {
                              staticClass: "required_field",
                              attrs: {
                                "hide-details": "",
                                label: _vm.$t("commodityWeight"),
                                rules: [
                                  _vm.fieldIsRequired("commodityWeight"),
                                  _vm.fieldIsNumber("commodityWeight"),
                                  function(v) {
                                    return (
                                      v > 0 ||
                                      this$1.$t("mustBeGreaterThanZero")
                                    )
                                  }
                                ],
                                suffix: _vm.unit
                              },
                              model: {
                                value: _vm.form.commodityWeight,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "commodityWeight", $$v)
                                },
                                expression: "form.commodityWeight"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("v-flex", { attrs: { xs3: "" } })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-layout",
                      { attrs: { "align-baseline": "", "justify-end": "" } },
                      [
                        _c(
                          "v-btn",
                          {
                            attrs: { dark: "", color: "primary" },
                            on: { click: _vm.addCommodity }
                          },
                          [_vm._v(_vm._s(_vm.$t("addCommodity")))]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e()
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cb78a880", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb78a880","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/HazardousCommodities.vue
// module id = null
// module chunks = 